<x-page-panel
  class="mini-cart"
  *ngIf="operationQState$ | async as operation"
  [panelLoading]="operation.status === 'loading'"
  [xOperation]="operation"
>
  <header class="p-3 py-2 border-bottom-color justify-content-between align-items-center">
    <h3 i18n="@@MiniCart.Title">Shopping Bag</h3>

    <x-close-button (click)="closeBagOverlay()"></x-close-button>
  </header>

  <ng-container *ngIf="order && orderSourceItems.length > 0; else NoItems">
    <!--scrollable body-->
    <div class="body-content">
      <x-order-summary [order]="order"></x-order-summary>
      <x-association-mini-bag
        *xABFeatureIf="'associations-source'; let featureVal; else: NO_TEST_ASSOCIATION"
        [testCase]="featureVal"
        class="p-3 border-top-color"
      ></x-association-mini-bag>
    </div>

    <footer class="p-3 pb-0 border-top-color">
      <x-order-totals class="section totals" [order]="order"></x-order-totals>
      <button
        xButtonSize="full"
        mat-flat-button
        color="primary"
        [url]="'/checkout/' + order.id"
        xNavigateWithRedirect
        [xButtonLoading]="buttonLoading$ | async"
        i18n="@@CallToAction.Checkout"
      >
        checkout
      </button>
      <button type="button" mat-button xButtonType="link" xNeedHelp color="primary">
        <fa-icon icon="question"></fa-icon>
        <span i18n="@@CallToAction.NeedHelp">Help</span>
      </button>
    </footer>
  </ng-container>

  <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
</x-page-panel>

<ng-template #NoItems>
  <div class="no-items p-3">
    <div class="text-center mb-2" i18n="@@MiniCart.Empty.Note">Your shopping bag is empty.</div>
    <button
      xButtonSize="full"
      mat-flat-button
      color="primary"
      (click)="closeBagOverlay()"
      i18n="@@CallToAction.StartShopping"
    >
      Start Shopping
    </button>
    <button type="button" mat-button xButtonType="link" xNeedHelp color="primary">
      <fa-icon icon="question"></fa-icon>
      <span i18n="@@CallToAction.NeedHelp">Help</span>
    </button>
  </div>
</ng-template>

<ng-template #NO_TEST_ASSOCIATION>
  <x-association-mini-bag class="p-3 border-top-color"></x-association-mini-bag>
</ng-template>
